import { useMsal } from "@azure/msal-react";
import { AccountCircle, ExpandMore } from "@mui/icons-material";
import { MenuItem, Popper } from "@mui/material";
import React, { ReactElement } from "react";
import TimeZoneMenuItem from "./timeZoneMenuItem";

export default function UserInfo(): ReactElement {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleHover = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div onMouseLeave={handleClose}>
      <MenuItem dense onMouseOver={handleHover}>
        <AccountCircle fontSize="large" sx={{ marginRight: "10px" }} />
        {account?.name}
        <ExpandMore />
      </MenuItem>
      <Popper id="userMenu" anchorEl={anchorEl} keepMounted disablePortal open={Boolean(anchorEl)}>
        <TimeZoneMenuItem />
        <MenuItem dense divider sx={{ cursor: "auto" }}>
          Rollen: {account?.idTokenClaims?.roles?.join(", ")}
        </MenuItem>
        <MenuItem
          dense
          onClick={() =>
            instance.acquireTokenRedirect({
              prompt: "select_account",
              scopes: ["api://" + process.env.VITE_API_CLIENT_ID + "/access_as_user"],
            })
          }
        >
          Als anderer Benutzer anmelden
        </MenuItem>
        <MenuItem dense onClick={() => instance.logout({ account: instance.getActiveAccount() ?? undefined })}>
          Abmelden
        </MenuItem>
      </Popper>
    </div>
  );
}
